import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import CertificateCard from "./CertificateCards";
import Particle from "../Particle";
import cpp from "../../Assets/certificate/cpp.jpg";
import javascript from "../../Assets/certificate/javascript.jpg";
import python from "../../Assets/certificate/python.jpg";
import sql from "../../Assets/certificate/sql.jpg";

function Certifications() {
  return (
    <Container fluid className="project-section">
      <Particle />
      <Container>
        <h1 className="project-heading">
          <strong className="purple">Certifications </strong>
        </h1>
        
        <Row style={{ justifyContent: "center", paddingBottom: "10px" }}>
          <Col md={4} className="project-card">
            <CertificateCard
              imgPath={javascript}
              isBlog={false}
              title="Javascript"
              ghLink="https://github.com/SwaggyRajput"
              demoLink="https://www.hackerrank.com/certificates/d342d22b916d"
            />
          </Col>

          <Col md={4} className="project-card">
            <CertificateCard
              imgPath={sql}
              isBlog={false}
              title="SQL"
              ghLink="https://github.com/SwaggyRajput"
              demoLink="https://www.hackerrank.com/certificates/a9bf866883e4"
            />
          </Col>

          <Col md={4} className="project-card">
            <CertificateCard
              imgPath={cpp}
              isBlog={false}
              title="C++"
              ghLink="https://github.com/SwaggyRajput"
              demoLink="https://www.hackerrank.com/certificates/06abbe9bcbcf"              
            />
          </Col>
         

          <Col md={4} className="project-card">
            <CertificateCard
              imgPath={python}
              isBlog={false}
              title="Python"
              ghLink="https://github.com/SwaggyRajput"
              demoLink="https://www.hackerrank.com/certificates/d342d22b916d"
            />
          </Col>

          

          
        </Row>
      </Container>
    </Container>
  );
}

export default Certifications;